
import { blogPosts } from "@/data/blog";
import { BlogPost } from "@/types/blog";

/**
 * Find a blog post by its slug
 */
export const findBlogPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find(post => post.slug === slug);
};

/**
 * Get the next and previous post based on current slug
 */
export interface AdjacentPosts {
  nextPost: BlogPost | null;
  previousPost: BlogPost | null;
}

export const getNextAndPreviousPost = (slug: string): AdjacentPosts => {
  const currentIndex = blogPosts.findIndex(post => post.slug === slug);
  
  if (currentIndex === -1) {
    return { nextPost: null, previousPost: null };
  }
  
  const previousPost = currentIndex > 0 ? blogPosts[currentIndex - 1] : null;
  const nextPost = currentIndex < blogPosts.length - 1 ? blogPosts[currentIndex + 1] : null;
  
  return { nextPost, previousPost };
};
